import * as React from "react";

import { DiagnosisStyleStepChips } from "./DiagnosisStyleStepChips";

// 登録導線のときだけステップチップス（投資力診断/投資方針書/プランナー）を出し、ホーム起点では出さない。
// intro / form の2ページが同じ出し分けをするため、ルールをここに一本化する
// （各ページに三項演算子をコピーすると、入口の種類が増えたときに更新漏れが起きるため）。
export const buildDiagnosisPhaseTags = (fromHome: boolean, isCompleted: boolean): React.ReactNode =>
  fromHome ? undefined : <DiagnosisStyleStepChips isCompleted={isCompleted} />;
